import React, {useEffect} from "react";
const Chat =()=>{
       useEffect(() => {
                const scriptUrls = [
                  "assets/js/jquery-3.7.1.min.js",
                  "assets/js/bootstrap.bundle.min.js",
                  "assets/plugins/swiper/swiper.min.js",
                  "assets/js/script.js"
                ];
            
                let isCancelled = false;
            
                const loadScriptsSequentially = async () => {
                  for (const url of scriptUrls) {
                    if (isCancelled) break;
            
                    await new Promise((resolve, reject) => {
                      const script = document.createElement('script');
                      script.src = url;
                      script.async = false;
                      script.onload = () => {
                        console.log(`Loaded: ${url}`);
                        resolve();
                      };
                      script.onerror = () => {
                        console.error(`Failed to load: ${url}`);
                        reject();
                      };
                      document.body.appendChild(script);
                    });
                  }
            
                  // Now init plugins after scripts are loaded
                  if (!isCancelled) {
                    // if (window.AOS) {
                    //   window.AOS.init();
                    // }
            
                    if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                      window.$('.datetimepicker').datetimepicker();
                    }
            
                    if (typeof window.initBackToTop === 'function') {
                      window.initBackToTop(); // assuming your backToTop script defines this
                    }
            
                    console.log('All scripts loaded and initialized.');
                  }
                };
            
                loadScriptsSequentially();
            
                return () => {
                  isCancelled = true;
                };
              }, []);
    return(
        <>
        
        <div className="page-wrapper chat-page-wrapper">
  <div className="container">
    <div className="content doctor-content">
      <div className="chat-sec">
        {/* sidebar group */}
        <div className="sidebar-group left-sidebar chat_sidebar">
          {/* Chats sidebar */}
          <div id="chats" className="left-sidebar-wrap sidebar active slimscroll">
            <div className="slimscroll-active-sidebar">
              {/* Left Chat Title */}
              <div className="left-chat-title all-chats">
                <div className="setting-title-head">
                  <h4> All Chats</h4>
                </div>
                <div className="add-section">
                  {/* Chat Search */}
                  <form>
                    <div className="user-chat-search">
                      <span className="form-control-feedback"><i className="fa-solid fa-magnifying-glass" /></span>
                      <input type="text" name="chat-search" placeholder="Search" className="form-control" />
                    </div>
                  </form>
                  {/* /Chat Search */}
                </div>
              </div>
              {/* /Left Chat Title */}
              {/* Top Online Contacts */}
              <div className="top-online-contacts">
                <div className="fav-title">
                  <h6>Online Now</h6>
                  {/*<a>*/} <button>View All</button>
                </div>
                <div className="swiper-container">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="top-contacts-box">
                        <div className="profile-img online">
                          <img src="assets/img/doctors-dashboard/profile-01.jpg" alt="Img" />
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="top-contacts-box">
                        <div className="profile-img online">
                          <img src="assets/img/doctors-dashboard/profile-04.jpg" alt="Img" />
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="top-contacts-box">
                        <div className="profile-img online">
                          <img src="assets/img/doctors-dashboard/profile-03.jpg" alt="Img" />
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="top-contacts-box">
                        <div className="profile-img online">
                          <img src="assets/img/doctors-dashboard/profile-08.jpg" alt="Img" />
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="top-contacts-box">
                        <div className="profile-img online">
                          <img src="assets/img/doctors-dashboard/profile-06.jpg" alt="Img" />
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="top-contacts-box">
                        <div className="profile-img online">
                          <img src="assets/img/doctors-dashboard/profile-07.jpg" alt="Img" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Top Online Contacts */}
              <div className="sidebar-body chat-body" id="chatsidebar">
                {/* Left Chat Title */}
                <div className="d-flex justify-content-between align-items-center ps-0 pe-0">
                  <div className="fav-title pin-chat">
                    <h6>Pinned Chat</h6>
                  </div>
                </div>
                {/* /Left Chat Title */}
                <ul className="user-list">
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div className="avatar avatar-online">
                        <img src="assets/img/doctors-dashboard/profile-01.jpg" alt="asset" />
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Adrian Marshall</h5>
                          <p>Have you called them?</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">Just Now</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-thumbtack me-2" />
                            <i className="fa-solid fa-check-double green-check" />
                          </div>
                        </div>    
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div className="avatar ">
                        <img src="assets/img/doctors-dashboard/doctor-profile-img.jpg" alt="asd" />
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Dr Joseph Boyd</h5>
                          <p><i className="isax isax-video5 me-1" />Video</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">Yesterday</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-thumbtack" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div className="avatar avatar-online">
                        <img src="assets/img/doctors-dashboard/profile-04.jpg" alt="asd" />
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Dr Edalin Hendry</h5>
                          <p><i className="fa-solid fa-file-lines me-1" />Prescription.doc</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">10:20 PM</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-thumbtack me-2" />
                            <i className="fa-solid fa-check-double green-check" />
                          </div>
                        </div>    
                      </div>
                    </button>
                  </li>
                </ul>
                {/* Left Chat Title */}
                <div className="d-flex justify-content-between align-items-center ps-0 pe-0">
                  <div className="fav-title pin-chat">
                    <h6>Recent Chat</h6>
                  </div>
                </div>
                {/* /Left Chat Title */}
                <ul className="user-list">
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div className="avatar avatar-online">
                        <img src="assets/img/doctors-dashboard/profile-02.jpg" alt="sda" />
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Kelly Stevens</h5>
                          <p>Have you called them?</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">Just Now</small>
                          <div className="new-message-count">2</div>
                        </div>    
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div>
                        <div className="avatar avatar-online">
                          <img src="assets/img/doctors-dashboard/profile-05.jpg" alt="asd" />
                        </div>
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Robert Miller</h5>
                          <p><i className="isax isax-video5 me-1" />Video</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">Yesterday</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-check" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div className="avatar">
                        <img src="assets/img/doctors-dashboard/profile-08.jpg" alt="asd" />
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Emily Musick</h5>
                          <p><i className="fa-solid fa-file-lines me-1" />Project Tools.doc</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">10:20 PM</small>
                        </div>    
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div>
                        <div className="avatar avatar-online">
                          <img src="assets/img/doctors-dashboard/profile-03.jpg" alt="asd" />
                        </div>
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Samuel James</h5>
                          <p><i className="fa-solid fa-microphone me-1" />Audio</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">12:30 PM</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-check-double green-check" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div>
                        <div className="avatar ">
                          <img src="assets/img/doctors-dashboard/profile-02.jpg" alt="asd" />
                        </div>
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Dr Shanta Neill</h5>
                          <p className="missed-call-col"><i className="isax isax-call5-flip me-1" />Missed Call</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">Yesterday</small>
                        </div>
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div>
                        <div className="avatar avatar-online">
                          <img src="assets/img/doctors-dashboard/profile-07.jpg" alt="asd" />
                        </div>
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Peter Anderson</h5>
                          <p>Have you called them?</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">23/03/24</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-check" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                  <li className="user-list-item">
                    {/*<a>*/} <button>
                      <div>
                        <div className="avatar">
                          <img src="assets/img/doctors-dashboard/profile-06.jpg" alt="asd" />
                        </div>
                      </div>
                      <div className="users-list-body">
                        <div>
                          <h5>Catherine Gracey</h5>
                          <p><i className="fa-solid fa-image me-1" />Photo</p>
                        </div>
                        <div className="last-chat-time">
                          <small className="text-muted">20/03/24</small>
                          <div className="chat-pin">
                            <i className="fa-solid fa-check-double" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* / Chats sidebar */}
        </div>
        {/* /Sidebar group */}
        {/* Chat */}
        <div className="chat chat-messages" id="middle">
          <div className="slimscroll">
            <div className="chat-inner-header">
              <div className="chat-header">
                <div className="user-details">
                  <div className="d-lg-none">
                    <ul className="list-inline mt-2 me-2">
                      <li className="list-inline-item">
                        <button className="text-muted px-0 left_sides" data-chat="open">
                          <i className="fas fa-arrow-left" />
                        </button>
                      </li>
                    </ul>
                  </div>
                  <figure className="avatar avatar-online">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" alt="asd" />
                  </figure>
                  <div className="mt-1">
                    <h5>Dr Edalin Hendry</h5>
                    <small className="last-seen">
                      Online
                    </small>
                  </div>
                </div>
                <div className="chat-options ">
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <button className="btn btn-outline-light chat-search-btn" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Search">
                        <i className="fa-solid fa-magnifying-glass" />
                      </button>
                    </li>
                    <li className="list-inline-item">
                      <button className="btn btn-outline-light no-bg" data-bs-toggle="dropdown">
                        <i className="fa-solid fa-ellipsis-vertical" />
                      </button>
                      <div className="dropdown-menu dropdown-menu-end">
                        <button className="dropdown-item ">Close Chat </button>
                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#mute-notification">Mute Notification</button>
                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#disappearing-messages">Disappearing Message</button>
                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#clear-chat">Clear Message</button>
                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#change-chat">Delete Chat</button>
                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#report-user">Report</button>
                        <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#block-user">Block</button>
                      </div>
                    </li>
                  </ul>
                </div>
                {/* Chat Search */}
                <div className="chat-search">
                  <form>
                    <span className="form-control-feedback"><i className="fa-solid fa-magnifying-glass" /></span>
                    <input type="text" name="chat-search" placeholder="Search Chats" className="form-control" />
                    <div className="close-btn-chat"><i className="fa fa-close" /></div>
                  </form>
                </div>
                {/* /Chat Search */}
              </div>
            </div>
            <div className="chat-body">
              <div className="messages">
                <div className="chats chats-right">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" className="dreams_chat" alt="std" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name text-end justify-content-end">
                      <h6>Andrea Kearns<span>8:16 PM</span></h6>
                      <div className="chat-action-btns ms-3">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content">
                      {/*<a>*/} <button>Hello Doctor, </button> could you tell a diet plan that suits for me?
                      <div className="emoj-group  right-emoji-group">
                        <ul>
                          <li className="emoj-action">{/*<a>*/} <button><i className="fa-regular fa-face-smile" /></button>
                            <div className="emoj-group-list">
                              <ul>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                              </ul>
                            </div>
                          </li>
                          <li><button data-bs-toggle="modal" data-bs-target="#forward-message"><i className="fa-solid fa-share" /></button></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-line">
                  <span className="chat-date">Today, March 25</span>
                </div>
                <div className="chats">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/doctor-profile-img.jpg" className="dreams_chat" alt="btn" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name">
                      <h6>Edalin Hendry<span>9:45 AM <i className="fa-solid fa-check-double green-check" /></span></h6>
                      <div className="chat-action-btns ms-3">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content ">
                      <div className="emoj-group">
                        <ul>
                          <li className="emoj-action">{/*<a>*/} <button><i className="fa-regular fa-face-smile" /></button>
                            <div className="emoj-group-list">
                              <ul>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                              </ul>
                            </div>
                          </li>
                          <li><button data-bs-toggle="modal" data-bs-target="#forward-message"><i className="fa-solid fa-share" /></button></li>
                        </ul>
                      </div>
                      <div className="chat-voice-group">
                        <ul>
                          <li>{/*<a>*/} <button><span><img src="assets/img/icons/play-01.svg" alt="icon" /></span></button></li>
                          <li><img src="assets/img/icons/voice.svg" alt="btn" /></li>
                          <li>0:05</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chats chats-right">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" className="dreams_chat" alt="btn" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name text-end justify-content-end">
                      <h6>Andrea Kearns<span>9:47 AM</span></h6>
                      <div className="chat-action-btns ms-2">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content award-link chat-award-link">
                      {/*<a>*/} <button className="mb-1">https://www.youtube.com/watch?v=GCmL3mS0Psk</button>
                      <img src="assets/img/sending-img.jpg" alt="btn" />
                      <div className="emoj-group right-emoji-group">
                        <ul>
                          <li className="emoj-action">{/*<a>*/} <button><i className="fa-regular fa-face-smile" /></button>
                            <div className="emoj-group-list">
                              <ul>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                              </ul>
                            </div>
                          </li>
                          <li><button data-bs-toggle="modal" data-bs-target="#forward-message"><i className="fa-solid fa-share" /></button></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chats">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/doctor-profile-img.jpg" className="dreams_chat" alt="asd" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name">
                      <h6>Edalin Hendry<span>9:50 AM <i className="fa-solid fa-check-double green-check" /></span></h6>
                      <div className="chat-action-btns ms-3">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content fancy-msg-box">
                      <div className="emoj-group">
                        <ul>
                          <li className="emoj-action">{/*<a>*/} <button><i className="fa-regular fa-face-smile" /></button>
                            <div className="emoj-group-list">
                              <ul>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                              </ul>
                            </div>
                          </li>
                          <li>{/*<a>*/} <button data-bs-toggle="modal" data-bs-target="#forward-message"><i className="fa-solid fa-share" /></button></li>
                        </ul>
                      </div>
                      <div className="download-col">
                        <ul className="nav mb-0">
                          <li>
                            <div className="image-download-col">
                              <a href="assets/img/media/media-02.jpg" data-fancybox="gallery" className="fancybox">
                                <img src="assets/img/media/media-02.jpg" alt="sdf" />
                              </a>
                            </div>
                          </li>
                          <li>
                            <div className="image-download-col ">
                              <a href="assets/img/media/media-03.jpg" data-fancybox="gallery" className="fancybox">
                                <img src="assets/img/media/media-03.jpg" alt="sdf" />
                              </a>
                            </div>
                          </li>
                          <li>
                            <div className="image-download-col image-not-download">
                              <a href="assets/img/media/media-01.jpg" data-fancybox="gallery" className="fancybox">
                                <img src="assets/img/media/media-01.jpg" alt="Img" />
                                <span>10+</span>
                              </a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chats chats-right">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" className="dreams_chat" alt="asd" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name text-end justify-content-end">
                      <h6>Andrea Kearns<span>8:16 PM</span></h6>
                      <div className="chat-action-btns ms-3">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content review-files">
                      <div className="file-download d-flex align-items-center mb-0">
                        <div className="file-type d-flex align-items-center justify-content-center me-2">
                          <i className="fa-solid fa-location-dot" />
                        </div>
                        <div className="file-details">
                          <span className="file-name">My Location</span>
                          <ul>
                            <li>{/*<a>*/} <button>Download</button></li>
                          </ul>
                        </div>
                      </div>
                      <div className="emoj-group right-emoji-group">
                        <ul>
                          <li className="emoj-action">{/*<a>*/} <button><i className="fa-regular fa-face-smile" /></button>
                            <div className="emoj-group-list">
                              <ul>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                              </ul>
                            </div>
                          </li>
                          <li><button data-bs-toggle="modal" data-bs-target="#forward-message"><i className="fa-solid fa-share" /></button></li>
                        </ul>
                      </div>
                    </div>
                    <div className="like-chat-grp">
                      <ul>
                        <li className="like-chat">{/*<a>*/} <button>2<img src="assets/img/icons/like.svg" alt="Icon" /></button></li>
                        <li className="comment-chat">{/*<a>*/} <button>2<img src="assets/img/icons/heart.svg" alt="Icon" /></button></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="chats chats-right">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" className="dreams_chat" alt="alt" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name text-end justify-content-end">
                      <h6>Andrea Kearns<span>8:16 PM</span></h6>
                      <div className="chat-action-btns ms-3">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content">
                      Thank you for your support
                      <div className="emoj-group right-emoji-group">
                        <ul>
                          <li className="emoj-action">{/*<a>*/} <button><i className="fa-regular fa-face-smile" /></button>
                            <div className="emoj-group-list">
                              <ul>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                                <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                                <li className="add-emoj">{/*<a>*/} <button /></li>
                              </ul>
                            </div>
                          </li>
                          <li>{/*<a>*/} <button data-bs-toggle="modal" data-bs-target="#forward-message"><i className="fa-solid fa-share" /></button></li>
                        </ul>
                      </div>
                    </div>                                    
                  </div>
                </div>			
                <div className="chats chats-right">
                  <div className="chat-avatar text-end justify-content-end">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" className="dreams_chat" alt="sdf" />
                  </div>
                  <div className="chat-content chat-cont-type">
                    <div className="chat-profile-name chat-type-wrapper">
                      <p>Andrea Kearns Typing...</p>
                    </div>
                  </div>
                </div>
                <div className="chats forward-chat-msg">
                  <div className="chat-avatar">
                    <img src="assets/img/doctors-dashboard/profile-06.jpg" className="dreams_chat" alt="sdf" />
                  </div>
                  <div className="chat-content">
                    <div className="chat-profile-name">
                      <h6>Andrea Kearns<span>8:16 PM</span></h6>
                      <div className="chat-action-btns ms-3">
                        <div className="chat-action-col">
                          <button className="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis" />
                          </button>
                          <div className="dropdown-menu chat-drop-menu dropdown-menu-end">
                            <button className="dropdown-item message-info-left">Message Info </button>
                            <button className="dropdown-item">Reply</button>
                            <button className="dropdown-item">React</button>
                            <button className="dropdown-item">Forward</button>
                            <button className="dropdown-item">Delete</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="message-content">
                      Thank you for your support
                    </div>
                  </div>
                </div>                           
              </div>
            </div>
          </div>
          <div className="chat-footer">
            <form>
              <div className="smile-foot">
                <div className="chat-action-btns">
                  <div className="chat-action-col">
                    <button className="action-circle" data-bs-toggle="dropdown">
                      <i className="fa-solid fa-ellipsis-vertical" />
                    </button>
                    <div className="dropdown-menu dropdown-menu-end">
                      <button className="dropdown-item "><span><i className="fa-solid fa-file-lines" /></span>Document</button>
                      <button className="dropdown-item"><span><i className="fa-solid fa-camera" /></span>Camera</button>
                      <button className="dropdown-item"><span><i className="fa-solid fa-image" /></span>Gallery</button>
                      <button className="dropdown-item"><span><i className="fa-solid fa-volume-high" /></span>Audio</button>
                      <button className="dropdown-item"><span><i className="fa-solid fa-location-dot" /></span>Location</button>
                      <button className="dropdown-item"><span><i className="fa-solid fa-user" /></span>Contact</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="smile-foot emoj-action-foot">
                <button className="action-circle"><i className="fa-regular fa-face-smile" /></button>
                <div className="emoj-group-list-foot down-emoji-circle">
                  <ul>
                    <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-01.svg" alt="Icon" /></button></li>
                    <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-02.svg" alt="Icon" /></button></li>
                    <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-03.svg" alt="Icon" /></button></li>
                    <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-04.svg" alt="Icon" /></button></li>
                    <li>{/*<a>*/} <button><img src="assets/img/icons/emoj-icon-05.svg" alt="Icon" /></button></li>
                    <li className="add-emoj">{/*<a>*/} <button><i className="fa-solid fa-plus" /></button></li>
                  </ul>
                </div>
              </div>
              <div className="smile-foot">
                <button className="action-circle"><i className="isax isax-microphone-2" /></button>
              </div>
              <input type="text" className="form-control chat_form" placeholder="Type your message here..." />
              <div className="form-buttons">
                <button className="btn send-btn" type="submit">
                  <i className="isax isax-send-25" />
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Chat */}
      </div>
    </div>
  </div>
</div>

        
  {/* Voice Call Modal */}
  <div className="modal fade call-modal" id="voice_call">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body">
          {/* Outgoing Call */}
          <div className="call-box incoming-box">
            <div className="call-wrapper">
              <div className="call-inner">
                <div className="call-user">
                  <img alt="User " src="assets/img/doctors/doctor-thumb-02.jpg" className="call-avatar" />
                  <h4>Darren Elder</h4>
                  <span>Connecting...</span>
                </div>							
                <div className="call-items">
                  {/*<a>*/} <button className="btn call-item call-end" data-bs-dismiss="modal" aria-label="Close"><i className="material-icons">call_end</i></button>
                  <a href="/" className="btn call-item call-start"><i className="material-icons">call</i></a>
                </div>
              </div>
            </div>
          </div>
          {/* Outgoing Call */}
        </div>
      </div>
    </div>
  </div>
  {/* /Voice Call Modal */}
  {/* Video Call Modal */}
  <div className="modal fade call-modal" id="video_call">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body">
          {/* Incoming Call */}
          <div className="call-box incoming-box">
            <div className="call-wrapper">
              <div className="call-inner">
                <div className="call-user">
                  <img className="call-avatar" src="assets/img/doctors/doctor-thumb-02.jpg" alt="User " />
                  <h4>Darren Elder</h4>
                  <span>Calling ...</span>
                </div>							
                <div className="call-items">
                  {/*<a>*/} <button className="btn call-item call-end" data-bs-dismiss="modal" aria-label="Close"><i className="material-icons">call_end</i></button>
                  <a href="/" className="btn call-item call-start"><i className="material-icons">videocam</i></a>
                </div>
              </div>
            </div>
          </div>
          {/* /Incoming Call */}
        </div>
      </div>
    </div>
  </div>
  {/* Video Call Modal */}


        </>
    );
}
export default Chat;